<h1
  data-test="title-matches"
  tabindex="0"
  class="iris-h1-responsive"
  data-dd-privacy="allow"
>
  Referrals
</h1>
<ng-container *ngIf="matchesState === 'matches'">
  <inline-notification
    *ngIf="matchLimitReached"
    [title]="matchLimitTitle"
    [body]="matchLimitBody"
    [priority]="'info'">
  </inline-notification>
  <div class="client-search">
    <div class="client-search-container">
      <client-search-bar
        searchLabel="Search"
        noSearchResultMessage="No matches found."
        [filters]="filterOptions.filter"
      ></client-search-bar>
    </div>
  </div>
  <iris-tab [hasTabGroup]="true" (tabGroupSelected)="reload($event)" #tabs activeFirstTab>
    <iris-tab-content *ngFor="let tab of tabsList; let index = index" label="{{tab.title}}{{tab.clientsCount}}" (selectedTab)="reload($event)">
      <div [ngClass]="{'hide-checkbox': matchClientStore.status !== clientStatus.ACCEPTED}" class="older-client-search">
        <iris-checkbox
          [formControl]="showOlderFormControl"
          data-test="show-clients-older-than-30-dayscheckbox"
        >
          Show accepted matches older than 30 days
        </iris-checkbox>
      </div>
      <member-match-clients-table
        [status]="$any(tab.status)"
        [showOlder]="showOlderFormControl.value"
        [timezone]="timezone"
        [reload]="matchClientStore.status"
        [showAvailabilityErrorState]="$any(showAvailabilityErrorState)"
      >
      </member-match-clients-table>
    </iris-tab-content>
  </iris-tab>
</ng-container>

<ng-container *ngIf="matchesState === 'noMatches'" data-dd-privacy="allow">
  <div
    class="client-list-empty-state"
    *ngIf="clients.length === 0"
  >
    <section *ngIf="user.acceptingClients">
      <img src="/assets/images/clients-list/no-matches.svg" alt="">
      <h2>No new matches yet</h2>
      <p>We'll let you know when you match with someone.</p>
      <p>Not interested in receiving matches? Update your availability.<br><br>
        <iris-button
          [buttonType]="IrisButtonTypes.PRIMARY"
          aria-label="Update availability"
          [routerLink]="['/scheduling/general_availability']"
          data-test="match-client-list-update-availability-button"
        >
          Update availability
        </iris-button>
      </p>
    </section>

    <section *ngIf="!user.acceptingClients" class="not-accepting">
      <img src="/assets/images/clients-list/no-matches-not-accepting.svg" alt="">
      <h3>Update your availability to get <br>matches</h3>
        <iris-button
          [buttonType]="IrisButtonTypes.PRIMARY"
          aria-label="Update availability"
          [routerLink]="['/scheduling/general_availability']"
          data-test="match-client-list-update-availability-button"
        >
          Update Availability
        </iris-button>
    </section>
  </div>
</ng-container>

<provider-not-accepting-clients-modal
  *ngIf="notAcceptingClientsModalOpen"
  [(modalOpen)]="notAcceptingClientsModalOpen"
  (modalOpenChange)="closeNotAcceptingClientsModal()"
></provider-not-accepting-clients-modal>
